import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import * as XLSX from "xlsx";
import { Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../context/LoaderContext";
import NpaListSection from "./ListSection";
import NpaAddImpExprtBtn from "./FilterPanel";
import {
  importUserList,
  reqToImportNpaProperties,
} from "../../redux/slice/propertiesSlice";
import DeletePopup from "../../components/delete-popup";
import {
  ArrowLeftIcon,
  DPIcon,
  FFormIcon,
  GDCRIcon,
  TPIcon,
  VillageIcon,
} from "../../assets/icons";
import {
  deleteAllProperty,
  npaAllProperties,
} from "../../redux/slice/allPropertiesSlice";
import {
  createMapFile,
  bulkCreateMapFiles,
  deleteMapFile,
  restoreMapFile,
  createMapLocation,
  fetchMapLocations,
  truncateNavStack,
  updateMapFile,
  updateMapLocation,
  setNavStack,
} from "../../redux/slice/mapSlice";
import AddStateModal from "./AddStateModal";
import BulkAddFilesModal from "./BulkAddFilesModal";
import { useToast } from "../../context/TostContext";
import { TabCard } from "../../components/custom-card/Cards";
import ImportModal from "../../components/modals/ImportModal";

// import { allUserList } from "../../redux/slice/userSlice";

export default function MapModule() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mapCode } = useParams();
  const { setLoading } = useLoader();
  const toast = useToast();
  // Pagination

  // Delete Property, Modal state
  const [openDeletePropertyModal, setOpenDeletePropertyModal] = useState(false);
  const [selectedDeleteProperty, setSelectedDeleteProperty] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Card Status
  const DEFAULT_STATUS = ""; // empty string = All Property

  // 2) Use it for initial state
  const [cardStatus, setCardStatus] = useState(DEFAULT_STATUS);
  // Add or Edit Form
  const [isEdit, setIsEdit] = useState(false);
  // search & Filter
  const [filterValues, setFilterValues] = useState({
    search: "",
    asset: "",
    property: [],
    possession: [],
    city: "",
    reservePrice: "",
    transaction: [],
    status: "",
    land_types: "",
  });
  // Open Modal for Import
  const [openImportModal, setOpenImportModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const searchTimeout = useRef(null);
  const [showTpModal, setShowTpModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // const [searchQuery, setSearchQuery] = useState("");  // Search query  // console.log("csvData",csvData);
  // Options for filters dropdown


  const mapTypes = useSelector((state) => state.maps.list);
  // const mapList = useSelector((state) => state.maps.mapList);
  const { mapList, isLoading } = useSelector((state) => state.maps);
  console.log("mapList", mapList);
  console.log("isLoading", isLoading);

  const nextLabel =
    mapList?.next_level_label?.charAt(0).toUpperCase() +
    mapList?.next_level_label?.slice(1);

  const count = mapList?.count;

  const currentMapType = useMemo(() => {
    return mapTypes.find(
      (m) => m.code.toLowerCase() === mapCode?.toLowerCase(),
    );
  }, [mapTypes, mapCode]);

  const headerPortalTarget = document.getElementById("header-portal-target");

  const mapName = useMemo(() => {
    if (!currentMapType?.code) return "";
    switch (currentMapType.code.toLowerCase()) {
      case "tp":
        return "TP";
      case "dp":
        return "DP";
      case "gdcr":
        return "GDCR";
      case "village":
        return "Village";
      case "fform":
        return "FFORM";
      default:
        return currentMapType.code.toUpperCase();
    }
  }, [currentMapType]);

  const headerContent = (
    <div className="d-flex align-items-center justify-content-between w-100">
      <h4 className="fw-semibold mb-0 text-primary fs-lg">
        <span className="text-muted fw-normal">Map / </span>{mapName}
      </h4>
    </div>
  );

  const importModalUsersList = useSelector(
    (state) => state?.property?.importBankUsers?.data || [],
  );

  const importModalUsers = importModalUsersList?.map((user) => ({
    id: user?.id,
    value: user?.id,
    label: user?.profile?.name,
    bankName: user?.profile?.bank?.bank_name,
    branchName: user?.profile?.branch?.branch_name,
    city: user?.profile?.branch?.branch_city,
  }));


  // Pagination
  // const defaultPerPageOptions = useMemo(
  //   () => [10, 25, 50, 100].map((n) => ({ value: n, label: String(n) })),
  //   []
  // );

  // const [limit, setLimit] = useState(initialPerPage);

  // const [perPageOptions, setPerPageOptions] = useState(defaultPerPageOptions);
  const totalMaps = mapList?.pagination?.total;

  const [limit, setLimit] = useState({ value: 10, label: 10 });
  const [currentPage, setCurrentPage] = useState(1);

  const navStack = useSelector((state) => state.maps.navStack);

  useEffect(() => {
    if (currentMapType?.id && !isInitialLoad) {
      const stateToSave = {
        parentId: mapList?.parent_id || null,
        navStack: navStack
      };
      sessionStorage.setItem(`map_state_${mapCode}`, JSON.stringify(stateToSave));
    }
  }, [mapList?.parent_id, navStack, mapCode, currentMapType?.id, isInitialLoad]);

  useEffect(() => {
    if (!currentMapType?.id) return;

    let targetParentId = mapList?.parent_id || null;

    if (isInitialLoad) {
      setLoading(true);
      const savedState = sessionStorage.getItem(`map_state_${mapCode}`);
      if (savedState) {
        try {
          const { parentId, navStack: savedNavStack } = JSON.parse(savedState);
          targetParentId = parentId;
          dispatch(setNavStack(savedNavStack));
        } catch (e) {
          console.error("Failed to parse saved map state", e);
        }
      }
    }

    dispatch(
      fetchMapLocations({
        map_type_id: currentMapType.id,
        parent_id: targetParentId,
        page: currentPage,
        limit: limit?.value,
        search: filterValues?.search || "",
        direction: "forward",
        mode: filterValues?.search ? "search" : "auto", // Updated logic
      }),
    ).finally(() => {
      if (isInitialLoad) {
        setLoading(false);
        setIsInitialLoad(false);
      }
    });
  }, [ // eslint-disable-line react-hooks/exhaustive-deps
    dispatch,
    currentMapType?.id,
    currentPage,
    limit?.value,
    filterValues?.search,
  ]);

  useEffect(() => {
    setSearchQuery("");
    setCurrentPage(1);
    setLimit({ value: 10, label: 10 });
    setIsInitialLoad(true);
  }, [mapCode]);


  const title =
    currentMapType?.code === "tp"
      ? "Total TP"
      : currentMapType?.code === "dp"
        ? "Total DP"
        : currentMapType?.code === "gdcr"
          ? "Total GDCR"
          : currentMapType?.code === "village"
            ? "Total Village"
            : currentMapType?.code === "fform"
              ? "Total FFORM"
              : "";

  const NpaPropertiesCard = [
    {
      id: 1,
      total: count || 0,
      title,
      icon:
        currentMapType?.code === "tp"
          ? <TPIcon />
          : currentMapType?.code === "dp"
            ? <DPIcon />
            : currentMapType?.code === "gdcr"
              ? <GDCRIcon />
              : currentMapType?.code === "village"
                ? <VillageIcon />
                : currentMapType?.code === "fform"
                  ? <FFormIcon />
                  : null,
      status: DEFAULT_STATUS,
    },
  ];

  const handleCardClick = (status) => {
    setCardStatus(status);
    setCurrentPage(1);
  };

  // const searchTimeout = useRef(null); // To store the timeout ID

  // Debounced Search Handler
  // const handleSearch = useCallback(() => {
  //   if (!searchQuery) {
  //     // Do not call API if searchQuery is empty
  //     return;
  //   }

  //   if (searchTimeout.current) {
  //     clearTimeout(searchTimeout.current); // Clear the previous timeout if the user is still typing
  //   }

  //   searchTimeout.current = setTimeout(() => {
  //     console.log("gauravss");

  //     dispatch(npaAllProperties({
  //       search: filterValues?.search,
  //       page: currentPage,
  //       limit: limit?.value,
  //       status: cardStatus,
  //       asset_category: filterValues?.asset,
  //       property_type: filterValues?.property,
  //       possession_type: filterValues?.possession,
  //       city_town: filterValues?.city,
  //       reserve_price: filterValues?.reservePrice,
  //     }));
  //   }, 1000); // 1000ms delay to wait before calling API
  // }, [filterValues, cardStatus, currentPage, searchQuery, dispatch, limit?.value]);

  // // Trigger the API call whenever filterValues or searchQuery changes
  // useEffect(() => {
  //   if (searchQuery) {
  //     handleSearch();
  //   }
  //   return () => clearTimeout(searchTimeout.current); // Clean up timeout on unmount or change
  // }, [handleSearch, searchQuery]);

  // A ref to hold the debounce timer

  // Debounce effect
  useEffect(() => {
    if (searchQuery === "") {
      setFilterValues((prev) => ({ ...prev, search: "" }));
      return;
    }

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setFilterValues((prev) => ({
        ...prev,
        search: searchQuery,
      }));
    }, 500);

    return () => clearTimeout(searchTimeout.current);
  }, [searchQuery]);

  console.log(filterValues, "filterValues");
  // console.log(filterValues,"filterValues");

  // useEffect(() => {
  //   dispatch(reqToGetFilterData({}));
  //   dispatch(propertyTypesDropdown({})).then((res) => {
  //     if (res?.payload?.success === true) {
  //       const formattedData = {
  //         propertyTypes: res?.payload?.data?.propertyTypes?.map(item => item?.name),
  //         assetCategories: res?.payload?.data?.assetCategories?.map(item => item?.name),
  //         possessionTypes: res?.payload?.data?.possessionTypes?.map(item => item?.name),
  //         auctionTypes: res?.payload?.data?.auctionTypes.map(item => item?.name),
  //       };
  //       setDropdownData(formattedData);
  //     }
  //   });
  // }, [dispatch]);


  const getCustomerActions = (item) => [
    {
      title: "Delete",
      handler: () => handlerDeleteProperty(item),
    },
  ];

  const refreshMapList = () =>
    dispatch(
      fetchMapLocations({
        map_type_id: currentMapType.id,
        parent_id: mapList?.parent_id || null,
        page: currentPage,
        limit: limit?.value,
        search: searchQuery || "",
        direction: "forward",
        mode: "auto",
        show_deleted: showDeleted,
      }),
    );

  const handleConfirmDeleteMap = () => {
    if (!mapToDelete) return;

    setIsSubmitting(true);

    dispatch(deleteMapFile({ id: mapToDelete.id }))
      .then((res) => {
        // Checked rather than assumed — the previous handler reported success
        // whatever came back, which is how a mis-wired action went unnoticed.
        if (res?.payload?.success) {
          toast.success(res.payload.message);
          setMapToDelete(null);
          refreshMapList();
        } else {
          toast.error(res?.payload?.message || "Failed to delete map");
        }
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleRestoreMap = (item) => {
    dispatch(restoreMapFile({ id: item.id })).then((res) => {
      if (res?.payload?.success) {
        toast.success(res.payload.message);
        refreshMapList();
      } else {
        // The title-clash refusal lands here, and it tells the operator what to
        // do about it — so it must be shown, not swallowed.
        toast.error(res?.payload?.message || "Failed to restore map");
      }
    });
  };

  const handlerDeleteProperty = (item) => {
    setSelectedDeleteProperty(item);
    setOpenDeletePropertyModal(true);
  };

  // Main Handler for Deleting NPA Properties
  const handleConfirmDelete = () => {
    try {
      setLoading(true);
      setIsSubmitting(true);
      dispatch(deleteAllProperty({ id: selectedDeleteProperty?.id })).then(
        (res) => {
          toast.success(res?.msg || "Property deleted successfully");
          setOpenDeletePropertyModal(false);
          dispatch(npaAllProperties({})).then((res) => {
            setLoading(false);
          });
        },
      );
    } catch (error) {
      toast.error(error?.msg || "Failed to delete Property");
      setLoading(false);
    } finally {
      setIsSubmitting(false);
      // setLoading(false); // Optional loader
      setOpenDeletePropertyModal(false);
    }
  };

  const handleEditBtn = (item) => {
    setIsEdit(true);
    navigate(`/broker-crm/properties/edit/${item.id}`, {
      state: { item, isEdit: true },
    });
  };

  // Handler for Exporting NPA Properties
  const handleExportNpaProperties = () => {
    try {
      setLoading(true);
      dispatch(
        npaAllProperties({
          search: filterValues?.search,
          page: currentPage,
          status: cardStatus,
          asset_category: filterValues?.asset,
          property_type: filterValues?.property,
          possession_type: filterValues?.possession,
          transaction_type: filterValues?.transaction,
          city_town: filterValues?.city,
          reserve_price: filterValues?.reservePrice,
          limit: 100000,
        }),
      ).then((res) => {
        const data = res?.payload?.properties;

        // console.log("data",data);

        if (!data || data.length === 0) {
          toast.error("No data available to Export");
          setLoading(false);
          return;
        }

        // Map the data for export
        const dataToExport = data?.map((item) => {
          return {
            borrower_names: item?.borrower_names || "-",
            property_type: item?.propertyType?.name || "-",
            asset_category: item?.assetCategory?.name || "-",
            land_area: item?.land_area || "-",
            builtup_carpet_area: item?.builtup_carpet_area || "-",
            dsc_required:
              item?.dsc_required === true
                ? "Yes"
                : item?.dsc_required === false
                  ? "No"
                  : "-",
            possession_type: item?.possessionType?.name || "-",
            auction_start_time: item?.auction_start_time
              ? new Date(item.auction_start_time).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
              : "-",
            auction_end_time: item?.auction_end_time
              ? new Date(item.auction_end_time).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
              : "-",
            property_inspection_datetime: item?.property_inspection_datetime
              ? new Date(item.property_inspection_datetime).toLocaleString(
                "en-IN",
                {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                },
              )
              : "-",
            auction_type: item?.auctionType?.name || "-",
            application_submission_date: item?.application_submission_date
              ? new Date(item.application_submission_date).toLocaleString(
                "en-IN",
                {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                },
              )
              : "-",
            time_extension: item?.time_extension || "-",
            property_address: item?.property_address || "-",
            area_locality: item?.area_locality || "-",
            taluka: item?.taluka || "-",
            city_town: item?.city_town || "-",
            province_state: item?.province_state || "-",
            country: item?.country || "-",
            service_provider: item?.service_provider || "-",
            description: item?.description || "-",
            bank_name: item?.Bank?.bank_name || "-",
            branch_name: item?.Branch?.branch_name || "-",
            emd: item?.emd || "-",
            reserve_price: item?.reserve_price || "-",
            min_increment: item?.min_increment || "-",
            amount_outstanding: item?.amount_outstanding || "-",
            contact_name: item?.contact_name || "-",
            contact_number: item?.contact_number || "-",
          };
        });

        // Export to Excel
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "NPA Properties");
        const fileName = "NPA Properties(Admin).xlsx";
        XLSX.writeFile(workbook, fileName);
        setLoading(false);
        dispatch(
          npaAllProperties({
            search: filterValues?.search,
            page: currentPage,
            status: cardStatus,
            asset_category: filterValues?.asset,
            property_type: filterValues?.property,
            possession_type: filterValues?.possession,
            transaction_type: filterValues?.transaction,
            city_town: filterValues?.city,
            reserve_price: filterValues?.reservePrice,
            limit: 10,
          }),
        );
      });
    } catch (error) {
      console.error("Error exporting data: ", error);
      toast.error("Error exporting data: ");
      setLoading(false); // Disable loading state on error
    }
  };

  // Import Btn Handler
  const importBtnHandler = () => {
    setOpenImportModal(true);
    dispatch(importUserList({ limit: 1000000 }));
  };

  // close Import Modal
  const handleImportSubmit = async (file, userId) => {
    const formData = new FormData();
    formData.append("properties_file", file);
    formData.append("assigned_to", userId);
    setLoading(true);
    try {
      const result = await dispatch(
        reqToImportNpaProperties({ data: formData }),
      ).unwrap();
      if (result) {
        toast.success(result?.msg || "Properties Imported Successfully!");
        dispatch(
          npaAllProperties({
            status: cardStatus,
            page: currentPage,
            limit: limit?.value,
            asset_category: filterValues?.asset,
            property_type: filterValues?.property,
            possession_type: filterValues?.possession,
            city_town: filterValues?.city,
            reserve_price: filterValues?.reservePrice,
            land_types: filterValues?.land_types,
          }),
        );
      }
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };



  const breadcrumbs = useMemo(() => {
    const crumbs = navStack.map((item) => {
      return {
        id: item?.parent_id,
        label: item?.mapList?.next_level_label,
      };
    });

    return crumbs;
  }, [navStack]);

  const handleBreadcrumbClick = (index) => {
    const parent_id = index === 0 ? null : breadcrumbs[index - 1].id;

    dispatch(truncateNavStack(index - 1));

    dispatch(
      fetchMapLocations({
        map_type_id: currentMapType.id,
        parent_id,
        page: 1,
        limit: limit?.value,
        direction: "back",
        mode: "navigate",
        search: "",
      }),
    );

    setSearchQuery("");
  };

  const isFileLevel = mapList?.type === "files";
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [mapToDelete, setMapToDelete] = useState(null);
  const [showDeleted, setShowDeleted] = useState(false);

  const paginationConfig = useMemo(() => ({
    currentPage,
    totalPages: Math.ceil(totalMaps / limit?.value) || 1,
    total: totalMaps || 0,
    onPageChange: (page) => setCurrentPage(page),
    pageSize: limit?.value,
    setPageSize: (size) => setLimit({ value: size, label: size }),
    setCurrentPage
  }), [currentPage, totalMaps, limit]);

  return (
    <>
      {headerPortalTarget && createPortal(headerContent, headerPortalTarget)}

      <Container fluid className="px-0">
        <div className="grid gap-4">
          {NpaPropertiesCard?.map((item, i) => (
            <TabCard
              key={i}
              className="g-col-4 g-col-xxl-3 mt-3"
              count={item?.total}
              title={item?.title}
              icon={item?.icon}
              active={item.status === cardStatus}
              iconClassName="icon-secondary"
              onClick={() => handleCardClick(item.status)}
            />
          ))}
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
          {/* Export, Import, Add Btn Section */}
          <div className="px-3 pt-2">

            <div className="jantri-breadcrumb">
              {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={`${crumb.id}-${index}`}>
                  <div className="breadcrumb-item">
                    <button
                      className="breadcrumb-label border-0 bg-transparent p-0 text-capitalize"
                      onClick={() => handleBreadcrumbClick(index)}
                    >
                      {crumb.label}
                    </button>
                  </div>

                  <i className="breadcrumb-separator">
                    <ArrowLeftIcon
                      width={20}
                      height={20}
                      className="rotate-180"
                    />
                  </i>
                </React.Fragment>
              ))}

              {/* Active / last breadcrumb */}
              <div className="breadcrumb-item">
                <span className="breadcrumb-label active text-capitalize">
                  {mapList?.next_level_label || "File"}
                </span>
              </div>
            </div>
          </div>
          <NpaAddImpExprtBtn
            navigate={navigate}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
            importBtnHandler={importBtnHandler}
            setCurrentPage={setCurrentPage}
            handleExportNpaProperties={handleExportNpaProperties}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onAddMapClick={() => setShowTpModal(true)}
            onBulkAddClick={() => setShowBulkModal(true)}
            showDeleted={showDeleted}
            onToggleDeleted={(next) => {
              setShowDeleted(next);
              setCurrentPage(1);
              dispatch(
                fetchMapLocations({
                  map_type_id: currentMapType.id,
                  parent_id: mapList?.parent_id || null,
                  page: 1,
                  limit: limit?.value,
                  search: searchQuery || "",
                  direction: "forward",
                  mode: "auto",
                  show_deleted: next,
                }),
              );
            }}
            title={nextLabel || "File"}
            isFileLevel={isFileLevel}

          // setSearchQuery={setSearchQuery}
          />

          {/* List Section */}
          <NpaListSection
            isEdit={isEdit}
            data={mapList?.data}
            navigate={navigate}
            currentPage={currentPage}
            handleEditBtn={handleEditBtn}
            getCustomerActions={getCustomerActions}
            currentMapType={currentMapType}
            mapList={mapList}
            setSearchQuery={setSearchQuery}
            setFilterValues={setFilterValues}
            setSelectedItem={setSelectedItem}
            setShowEditModal={setShowEditModal}
            setIsViewOnly={setIsViewOnly}
            limit={limit?.value}
            isFileLevel={Boolean(isFileLevel)}
            onDeleteMap={(row) => setMapToDelete(row)}
            onRestoreMap={handleRestoreMap}
            setCurrentPage={setCurrentPage}
            searchQuery={searchQuery}
            filterValues={filterValues}
            isLoading={isLoading}
            isInitialLoad={isInitialLoad}
            pagination={paginationConfig}
          />
        </div>
      </Container>

      {/* Map file delete — soft, and the copy says so. */}
      <DeletePopup
        show={Boolean(mapToDelete)}
        onHide={() => setMapToDelete(null)}
        title="Delete this map?"
        removeTitle="Cancel"
        onConfirm={handleConfirmDeleteMap}
        disabled={isSubmitting}
        saveTitle={isSubmitting ? "Deleting..." : "Delete"}
        content={
          <div className="tp-delete-content">
            <p className="mb-2">
              <strong>{mapToDelete?.title || "This map"}</strong> will be hidden from
              the app straight away. You can restore it later.
            </p>

            {mapToDelete?.georeference && (
              <div className="tp-delete-note">
                <p className="mb-1">
                  This map is georeferenced — its overlay will stop appearing for
                  users.
                </p>
                <p className="mb-0">
                  Its georeferencing and tiles are kept, so restoring brings it back
                  complete.
                </p>
              </div>
            )}
          </div>
        }
      />

      {/* Delete Modal */}
      <DeletePopup
        show={openDeletePropertyModal}
        onHide={() => setOpenDeletePropertyModal(false)}
        content="Are you sure you want to delete this Property?"
        removeTitle="Cancel"
        onConfirm={handleConfirmDelete}
        disabled={isSubmitting}
        saveTitle={isSubmitting ? "Deleting..." : "Delete"}
      />

      <ImportModal
        isOpen={openImportModal}
        onClose={() => setOpenImportModal(false)}
        users={importModalUsers}
        onSubmit={handleImportSubmit}
        title="Import Properties"
      />
      <BulkAddFilesModal
        isOpen={showBulkModal}
        onClose={() => setShowBulkModal(false)}
        title="Bulk Upload Files"
        keyboard={false}
        className="tp-file-modal"
        onSubmit={async ({ files, titles }) => {
          const res = await dispatch(
            bulkCreateMapFiles({
              map_type_id: currentMapType.id,
              location_id: mapList?.parent_id || null,
              files,
              titles,
            }),
          );

          // A refused request — a limit, or a bad location — has no report to
          // show. Surface it and let the modal keep the rows for another try.
          if (!res?.payload?.success) {
            toast.error(res?.payload?.message || "Upload failed");
            return null;
          }

          const report = res.payload.data;
          const landed =
            (report.created?.length || 0) + (report.replaced?.length || 0);

          if (landed > 0) {
            toast.success(res.payload.message);

            // Refreshed once for the whole batch rather than per file.
            setCurrentPage(1);
            dispatch(
              fetchMapLocations({
                map_type_id: currentMapType.id,
                parent_id: mapList?.parent_id || null,
                page: 1,
                limit: limit?.value,
                search: searchQuery || "",
                direction: "forward",
                mode: "auto",
              }),
            );
          }

          // Returned rather than closing: rows that failed stay on screen with
          // their reason so the operator can fix a title and retry just those.
          return report;
        }}
      />

      <AddStateModal
        isOpen={showTpModal}
        onClose={() => {
          setShowTpModal(false);
          setIsViewOnly(false);
        }}
        title={`${isViewOnly ? "View" : "Add"} ${nextLabel || "File"}`}
        rawTitle={nextLabel || "File"}
        isFileLevel={isFileLevel}
        isView={isViewOnly}

        keyboard={false}
        className="tp-file-modal"
        onSubmit={(payload) => {
          const action = isFileLevel
            ? createMapFile({
              map_type_id: currentMapType.id,
              location_id: mapList?.parent_id || null,
              file: payload.file,
              title: payload.title,
            })
            : createMapLocation({
              map_type_id: currentMapType.id,
              parent_id: mapList?.parent_id || null,
              name: payload.name,
              latitude: payload.latitude,
              longitude: payload.longitude,
            });
          setLoading(true);
          return dispatch(action).then((res) => {
            setLoading(false);
            const success = res?.payload?.success;

            if (success) {
              toast.success(
                isFileLevel
                  ? "File added successfully"
                  : "Location added successfully",
              );

              setCurrentPage(1);

              dispatch(
                fetchMapLocations({
                  map_type_id: currentMapType.id,
                  parent_id: mapList?.parent_id || null,
                  page: 1,
                  limit: limit?.value,
                  search: searchQuery || "",
                  direction: "forward",
                  mode: "auto",
                }),
              );
              setShowTpModal(false);
            } else {
              toast.error(res?.payload?.message);
              throw new Error(res?.payload?.message || "Failed to add");
            }
          }).catch((err) => {
            setLoading(false);
            throw err;
          });
        }}
      />
      <AddStateModal
        isOpen={showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setIsViewOnly(false);
        }}
        title={`${isViewOnly ? "View" : selectedItem ? "Update" : "Add"} ${nextLabel || "File"}`}
        rawTitle={nextLabel || "File"}
        isFileLevel={isFileLevel}
        isView={isViewOnly}
        defaultValue={selectedItem}
        keyboard={false}
        className="tp-file-modal"
        onSubmit={(payload) => {
          const action = isFileLevel
            ? updateMapFile({
              id: selectedItem.id,
              file: payload.file,
              title: payload.title,
            })
            : updateMapLocation({
              id: selectedItem.id,
              name: payload.name,
              latitude: payload.latitude,
              longitude: payload.longitude,
            });
          setLoading(true);
          return dispatch(action).then((res) => {
            setLoading(false);
            const success = res?.payload?.success;

            if (success) {
              toast.success(
                isFileLevel
                  ? "File updated successfully"
                  : "Location updated successfully",
              );

              dispatch(
                fetchMapLocations({
                  map_type_id: currentMapType.id,
                  parent_id: mapList?.parent_id || null,
                  page: currentPage,
                  limit: limit?.value,
                  search: searchQuery || "",
                  direction: "forward",
                  mode: "auto",
                }),
              );
              setShowEditModal(false);
            } else {
              toast.error(res?.payload?.message || "Update failed");
              throw new Error(res?.payload?.message || "Update failed");
            }
          }).catch((err) => {
            setLoading(false);
            throw err;
          });
        }}
      />
    </>
  );
}
